import { Plugin } from "vue";
import router from "../router";
import { PublicPageSymbol } from "./injectionSymbols";

const PublicTokenParamKey = "public_token";

const PublicTokenLegacyPath = "/login-public";
const PublicTokenLegacyParamKey = "t";

declare module "vue" {
	interface ComponentCustomProperties {
		$isPublic: boolean;
	}
}

export function useIsPublic() {
	const api = inject(PublicPageSymbol);
	if (api == null) {
		throw new Error(
			"PublicPagePlugin not created or this function was not called in a setup function"
		);
	}

	return api;
}

export const publicPage: Plugin = {
	install(app) {
		const url = new URL(window.location.href);

		let redirectToRoot = false;

		let publicToken: string | null = url.searchParams.get(PublicTokenParamKey);
		if (publicToken == null && url.pathname === PublicTokenLegacyPath) {
			publicToken = url.searchParams.get(PublicTokenLegacyParamKey);
			redirectToRoot = true;
		}

		const isPublic = publicToken != null;

		if (isPublic) {
			// Ensure the token is always in the url
			router.beforeEach((to) => {
				if (to.query[PublicTokenParamKey] !== publicToken) {
					return {
						...to,
						query: {
							...to.query,
							[PublicTokenParamKey]: publicToken,
						},
					};
				}
			});

			router.isReady().then(() => {
				if (redirectToRoot) {
					router.push("/");
				}
			});
		}

		app.provide(PublicPageSymbol, {
			isPublic,
			token: publicToken,
		});

		app.config.globalProperties.$isPublic = isPublic;
	},
};
